import $axios from './request';
// 获取供应商列表
export const orderSupplier = (data) => {
    return $axios.post('ordersConfig/company', data)
}
//客户采购订单 获取供应商列表
export const cpoGetVendor = (params = {}) => {
    return $axios.get('cpo/getVendor', { params })
}
// 获取银行列表
export const orderPayment = (data) => {
    return $axios.post('ordersConfig/payment', data)
}
// 获取产品列表
export const orderModel = (data) => {
    return $axios.post('ordersConfig/model', data)
}
// 获取品牌列表
export const orderBrand = (data) => {
    return $axios.post('ordersConfig/brand', data)
}
// 获取交期列表
export const orderLeading = (data) => {
    return $axios.post('ordersConfig/leading', data)
}
// 获取货况列表
export const orderCondition = (data) => {
    return $axios.post('ordersConfig/condition', data)
}
// 获取用户列表
export const ordersConfigGetUser = (data) => {
    return $axios.post('ordersConfig/getUser', data)
}
//获取发货弹窗采购
export const ocAllPurchaser = (data) => {
    return $axios.post('oc/allPurchaser', data)
}
// 获取用户和供应商
export const orderUser = (data) => {
    return $axios.post('ordersConfig/getCustomer', data)
}
// 获取用户和供应商地址
export const ordersConfigCustomerAddress = (params = {}) => {
    return $axios.get('ordersConfig/customerAddress', { params })
}
//添加用户和供应商地址
export const ordersAddAddress = (data) => {
    return $axios.post('orders/addAddress', data)
}
// 获取销售的客户
export const ordersConfigGetMissuUser = (data) => {
    return $axios.post('ordersConfig/getMissuUser', data)
}
// 获取货币类型
export const ordersConfigCurrent = (data) => {
    return $axios.post('ordersConfig/current', data)
}
// 创建订单
export const ordersAdd = (data) => {
    return $axios.post('orders/add', data)
}
//  订单列表
export const orderList = (data) => {
    return $axios.post('orders/list', data)
}
// 订单详情
export const orderDetail = (data) => {
    return $axios.post('orders/item', data)
}
// 订单编辑
export const orderEdit = (data) => {
    return $axios.post('orders/edit', data)
}
// 订单删除
export const orderDelete = (data) => {
    return $axios.post('orders/delete', data)
}
// 订单产品删除
export const orderProductDelete = (data) => {
    return $axios.post('orders/deleteItem', data)
}
// 获取订单ID列表
export const oederidList = (data) => {
    return $axios.post('ordersConfig/getOrders', data)
}
// copy to order
export const copyOrder = (data) => {
    return $axios.post('orders/copyOrder', data)
}
// copy to order 保存
export const orderSaveCopyToOrder = (data) => {
    return $axios.post('orders/saveCopyToOrder', data)
}
// from rfq 
export const orderFromRfq = (data) => {
    return $axios.post('orders/rfq', data)
}
// 保存 from rfq
export const orderFromRfqSave = (data) => {
    return $axios.post('orders/doOrder', data)
}
//from qtn
export const orderFromQtn = (data) => {
    return $axios.post('orders/quotation', data)
}
// 获取clearance
export const orderClearance = (data) => {
    return $axios.post('orders/clearance', data)
}
// 保存清关信息
export const orderClearanceSave = (data) => {
    return $axios.post('orders/clearance', data)
}
// 历史记录
export const ordersHistory = (data) => {
    return $axios.post('orders/history', data)
}
// 获取订单售后数据
export const ordersAfter = (params = {}) => {
    return $axios.get('orders/after', { params })
}
// 获取产品价格曲线数据
export const ordersProductRecord = (data) => {
    return $axios.post('orders/productRecord', data)
}
//订单入账记录
export const ordersPaiedRecord = (params = {}) => {
    return $axios.get('orders/paiedRecord', { params })
}
// 获取订单小计
export const ordersServiceCharge = (data) => {
    return $axios.post('orders/serviceCharge', data)
}
// 获取发票数据
export const ordersClearanceData = (data) => {
    return $axios.post('orders/clearanceData', data)
}
// 获取产品历史记录
export const ordersProductOld = (data) => {
    return $axios.post('orders/productOld', data)
}
// 创建采购任务
export const purchaseOrderteskAdd = (data) => {
    return $axios.post('purchaseOrdertesk/add', data)
}
// 获取已采购数据
export const ordersPurchaseTesk = (data) => {
    return $axios.post('orders/purchaseTesk', data)
}
// 获取多条订单明细
export const ordersGetAddShiptaskData = (data) => {
    return $axios.post('orders/getAddShiptaskData', data)
}
// 创建发货任务
export const ordersAddShiptask = (data) => {
    return $axios.post('orders/addShiptask', data)
}
// 获取采购任务列表
export const purchaseOrderTakeList = (data) => {
    return $axios.post('purchaseOrdertesk/list', data)
}
// 获取采购任务详情
export const purchaseOrderteskDetail = (data) => {
    return $axios.post('purchaseOrdertesk/detailed', data)
}
//调配采购任务
export const purchaseOrderteskReassign = (data) => {
    return $axios.post('purchaseOrdertesk/reassign', data)
}
// 退回采购任务
export const purchaseOrderteskCallbackOrder = (data) => {
    return $axios.post('purchaseOrdertesk/callbackOrder', data)
}
// 删除采购任务
export const purchaseOrderteskDelete = (data) => {
    return $axios.post('purchaseOrdertesk/delete', data)
}
//创建采购订单
export const purchaseOrderAdd = (data) => {
    return $axios.post('purchaseOrder/add', data)
}
// 获取库存价格列表
export const purchaseOrderWarehouse = (params = {}) => {
    return $axios.get('purchaseOrder/warehouse', { params })
}
// 获取采购订单列表
export const purchaseOrderList = (data) => {
    return $axios.post('purchaseOrder/list', data)
}
// 获取采购订单详情
export const purchaseOrderDetailed = (data) => {
    return $axios.post('purchaseOrder/detailed', data)
}
// 导出采购单
export const purchaseOrderExportPurchase = (data) => {
    return $axios.post('purchaseOrder/exportPurchase', data)
}
// 删除采购单
export const purchaseOrderDelete = (data) => {
    return $axios.post('purchaseOrder/delete', data)
}
// 删除采购单详情
export const purchaseOrderDeleteDetailed = (data) => {
    return $axios.post('purchaseOrder/deleteDetailed', data)
}
// 编辑价格
export const purchaseOrderEditPrice = (data) => {
    return $axios.post('purchaseOrder/editPrice', data)
}
//采购单获取全部销售
export const ocAllSales = (data) => {
    return $axios.post('oc/allSales', data)
}
// 获取银行列表
export const paymentList = (data) => {
    return $axios.post('payment/list', data)
}
// 获取银行余额
export const paymentBalance = (params = {}) => {
    return $axios.get('payment/balance', { params })
}
// 获取入账信息列表
export const ordersConfigPaymentConfi = (params = {}) => {
    return $axios.get('ordersConfig/paymentConfi', { params })
}
// 获取国家列表
export const ordersConfigCountry = (params = {}) => {
    return $axios.get('ordersConfig/country', { params })
}
// 获取入账记录列表
export const paymentRecord = (data) => {
    return $axios.post('payment/record', data)
}
// 添加入账记录
export const paymentAdd = (data) => {
    return $axios.post('payment/add', data)
}
// 获取出入账列表
export const ordersConfigPaymentOrders = (data) => {
    return $axios.post('ordersConfig/paymentOrders', data)
}
// 获取编辑入账记录
export const paymentEdit = (data) => {
    return $axios.post('payment/edit', data)
}
// 保存编辑入账记录
export const paymentSaveEdit = (data) => {
    return $axios.post('payment/saveEdit', data)
}
// 编辑轮询
export const paymentRecordPollingEdit = (params = {}) => {
    return $axios.get('paymentRecord/pollingEdit', { params })
}
// 销售删除待审核的资金池记录
export const paymentDel = (params = {}) => {
    return $axios.get('payment/del', { params })
}
// 获取excel模板
export const ordersExcelTemplate = (data) => {
    return $axios.post('orders/excelTemplate', data)
}
// 导出PI
export const ordersExportPI = (params = {}) => {
    return $axios.get('orders/exportPI', { params })
}
// 财务审核
export const paymentProcess = (data) => {
    return $axios.post('payment/process', data)
}
// 获取汇率
export const paymentGetrate = (data) => {
    return $axios.post('payment/getRate', data)
}
// 获取财务余额
export const paymentRecordFundPoolBalance = (params = {}) => {
    return $axios.get('paymentRecord/fundPoolBalance', { params })
}
// 获取资金来源和目标
export const paymentRecordFromNametoName = (params = {}) => {
    return $axios.get('paymentRecord/fromName_toName', { params })
}
// 获取类别
export const paymentRecordCategoryList = (params = {}) => {
    return $axios.get('paymentRecordCategory/list', { params })
}
// 获取支付记录列表
export const paymentRecordList = (data) => {
    return $axios.post('paymentRecord/list', data)
}
// 获取货代月账单记录
export const paymentShippingMonthlyBill = (params = {}) => {
    return $axios.get('paymentShipping/monthlyBill', { params })
}
// 获取货代
export const paymentShippingSearchData = (params = {}) => {
    return $axios.get('paymentShipping/searchData', { params })
}
// 添加付款记录
export const paymentRecordAdd = (data) => {
    return $axios.post('/paymentRecord/add', data)
}
// 获取运输任务
export const paymentShippingShiptask = (params = {}) => {
    return $axios.get('paymentShipping/shiptask', { params })
}
// 添加月账单
export const paymentShippingAdd = (data) => {
    return $axios.post('paymentShipping/add', data)
}
// 获取月账单明细
export const paymentShippingList = (params = {}) => {
    return $axios.get('paymentShipping/list', { params })
}
// 获取确认运费列表
export const paymentShippingIdentifyAmount = (params = {}) => {
    return $axios.get('paymentShipping/identifyAmount', { params })
}
// 运费列表保存
export const paymentShippingSaveIdentifyAmount = (params = {}) => {
    return $axios.get('paymentShipping/saveIdentifyAmount', { params })
}
// 编辑明细
export const paymentShippingEditDetailed = (data) => {
    return $axios.post('paymentShipping/editDetailed', data)
}
// 获取各银行汇率
export const paymentConfigGetRate = (params = {}) => {
    return $axios.get('paymentConfig/getRate', { params })
}
// 获取薪资列表
export const userSalaryList = (params = {}) => {
    return $axios.get('userSalary/list', { params })
}
//添加用户薪资
export const userSalaryAdd = (data) => {
    return $axios.post('userSalary/add', data)
}
// 获取签约公司列表
export const businessList = (params = {}) => {
    return $axios.get('business/list', { params })
}
// 获取所有用户
export const userSalarygetUser = (params = {}) => {
    return $axios.get('userSalary/getUser', { params })
}
// 获取提成方式算法
export const userPerkList = (params = {}) => {
    return $axios.get('userPerk/list', { params })
}
//编辑薪资
export const userSalaryEdit = (data) => {
    return $axios.post('userSalary/edit', data)
}
// 获取提成算法明细
export const userSalarygetTeamtakes = (params = {}) => {
    return $axios.get('userSalary/getTeamtakes', { params })
}
// 添加签约公司
export const businessAdd = (data) => {
    return $axios.post('business/add', data)
}
//编辑签约公司
export const businessEdit = (data) => {
    return $axios.post('business/edit', data)
}
//删除签约公司
export const businessDel = (params = {}) => {
    return $axios.get('business/del', { params })
}
//修改为已离职状态
export const userSalaryEditLeave = (data) => {
    return $axios.post('userSalary/editLeave', data)
}
// 获取下级用户
export const ordersConfigGetBelowUser = (params = {}) => {
    return $axios.get('ordersConfig/getBelowUser', { params })
}
//获取订单全部状态
export const ordersConfigOrderState = (params = {}) => {
    return $axios.get('ordersConfig/orderState', { params })
}
// 采购单如提成
export const purchaseOrderPerk = (data) => {
    return $axios.post('purchaseOrder/perk', data)
}
//获取佣金月账单和付款记录
export const paymentSalarySalaryList = (params = {}) => {
    return $axios.get('paymentSalary/salaryList', { params })
}
// 获取佣金员工列表
export const userSalaryGetSalary = (params = {}) => {
    return $axios.get('userSalary/getSalary', { params })
}
//添加月薪资记录
export const paymentSalaryAdd = (data) => {
    return $axios.post('paymentSalary/add', data)
}
//获取个人提成列表
export const paymentSalaryAlonePerk = (params = {}) => {
    return $axios.get('paymentSalary/alonePerk', { params })
}
//获取佣金明细
export const paymentSalaryList = (params = {}) => {
    return $axios.get('paymentSalary/list', { params })
}
// 编辑佣金明细
export const paymentSalaryEdit = (data) => {
    return $axios.post('paymentSalary/edit', data)
}
//获取团队列表
export const paymentSalaryTeamPerk = (params = {}) => {
    return $axios.get('paymentSalary/teamPerk', { params })
}
//获取已结算的采购订单
export const paymentSalarySettledPurchase = (params = {}) => {
    return $axios.get('paymentSalary/settledPurchase', { params })
}
//获取已结算的销售订单
export const paymentSalarySettledOrder = (params = {}) => {
    return $axios.get('paymentSalary/settledOrder', { params })
}
//添加采购结算
export const paymentSalaryPurchasePerk = (data) => {
    return $axios.post('paymentSalary/purchasePerk', data)
}
//添加销售结算
export const paymentSalaryOrderPerk = (data) => {
    return $axios.post('paymentSalary/orderPerk', data)
}
//获取月份ID PUT类型
export const paymentConfigGetMonth = (params = {}) => {
    return $axios.get('paymentConfig/getMonth', { params })
}
// 配置添加地址
export const regionAdd = (data) => {
    return $axios.post('region/add', data)
}
//获取配置地址列表
export const regionList = (params = {}) => {
    return $axios.get('region/list', { params })
}
// 配置编辑地址
export const regionEdit = (data) => {
    return $axios.post('region/edit', data)
}
//删除配置地址
export const regionDel = (params = {}) => {
    return $axios.get('region/del', { params })
}
// 获取房租类型
export const paymentRentGetCategory = (params = {}) => {
    return $axios.get('paymentRent/getCategory', { params })
}
// 添加房租地址信息
export const paymentRentRoomAdd = (data) => {
    return $axios.post('paymentRent/roomAdd', data)
}
// 获取房租地址列表
export const paymentRentRoomList = (params = {}) => {
    return $axios.get('paymentRent/roomList', { params })
}
//编辑房租地址信息
export const paymentRentRoomEdit = (data) => {
    return $axios.post('paymentRent/roomEdit', data)
}
// 删除房租地址信息
export const paymentRentRoomDisable = (params = {}) => {
    return $axios.get('paymentRent/roomDisable', { params })
}
//添加房租水电月单
export const paymentRentMonthAdd = (data) => {
    return $axios.post('paymentRent/monthAdd', data)
}
// 获取房租水电地址
export const paymentRentGetRoom = (params = {}) => {
    return $axios.get('paymentRent/getRoom', { params })
}
//获取房租水电月单
export const paymentRentMonthList = (params = {}) => {
    return $axios.get('paymentRent/monthList', { params })
}
// 获取房租水电已付款记录
export const paymentRentPaied = (params = {}) => {
    return $axios.get('paymentRent/paied', { params })
}
// 获取社保公积金月单
export const paymentInsureList = (params = {}) => {
    return $axios.get('paymentInsure/list', { params })
}
// 获取社保公积金已付款记录
export const paymentInsurePaied = (params = {}) => {
    return $axios.get('paymentInsure/paied', { params })
}
// 获取社保公积金明细
export const paymentInsureDetail = (params = {}) => {
    return $axios.get('paymentInsure/detail', { params })
}
//新增办公设备类型（新）
export const paymentOfficeOfficeStockAdd = (data) => {
    return $axios.post('paymentOffice/officeStockAdd', data)
}
//编辑办公设备类型 (新)
export const paymentOfficeOfficeStockEdit = (data) => {
    return $axios.post('paymentOffice/officeStockEdit', data)
}
// 获取设备配置列表
export const PaymentOfficeOfficeStock = (params = {}) => {
    return $axios.get('PaymentOffice/officeStock', { params })
}
// 获取设备类型
export const paymentConfigGetOffice = (params = {}) => {
    return $axios.get('paymentConfig/getOffice', { params })
}
// 获取设备类型（新）
export const PaymentOfficeGetOffice = (params = {}) => {
    return $axios.get('PaymentOffice/getOffice', { params })
}
//新增采购记录（办公设备）
export const paymentOfficePurcahseAdd = (data) => {
    return $axios.post('paymentOffice/purcahseAdd', data)
}
// 添加办公报废记录
export const PaymentOfficeDiscardAdd = (data) => {
    return $axios.post('PaymentOffice/discardAdd', data)
}
// 分配办公设备
export const PaymentOfficeOfficeDetailAdd = (data) => {
    return $axios.post('PaymentOffice/officeDetailAdd', data)
}
//办公设备详情
export const PaymentOfficeOfficeDetail = (params = {}) => {
    return $axios.get('PaymentOffice/officeDetail', { params })
}
//采购||报废记录
export const PaymentOfficePurchaseRecord = (params = {}) => {
    return $axios.get('PaymentOffice/purchaseRecord', { params })
}
// 更改使用者
export const PaymentOfficeOfficeDetailEdit = (data) => {
    return $axios.post('PaymentOffice/officeDetailEdit', data)
}
// 添加耗材类型
export const paymentConsumableConsumAdd = (data) => {
    return $axios.post('paymentConsumable/consumAdd', data)
}
// 获取类型id列表
export const paymentConfigGetConsume = (params = {}) => {
    return $axios.get('paymentConfig/getConsume', { params })
}
//获取耗材支付记录
export const paymentConsumablePaied = (params = {}) => {
    return $axios.get('paymentConsumable/paied', { params })
}
//添加日常报销类型
export const paymentExpendCategoryAdd = (data) => {
    return $axios.post('paymentExpend/categoryAdd', data)
}
// 获取日常报销采购记录
export const paymentExpendPurchaseRecordPaied = (params = {}) => {
    return $axios.get('paymentExpend/purchaseRecord/paied', { params })
}
// 转出货款订单产品列表
export const paymentPurcharseOrderList = (params = {}) => {
    return $axios.get('paymentPurcharse/orderList', { params })
}
//获取采购单
export const paymentConfigPurchaseOrder = (params = {}) => {
    return $axios.get('paymentConfig/purchaseOrder', { params })
}
// 获取资金池
export const paymentConfigFundPool = (params = {}) => {
    return $axios.get('paymentConfig/fundPool', { params })
}
// 获取案件列表
export const paymentCaseList = (params = {}) => {
    return $axios.get('paymentCase/list', { params })
}
// 财务获取订单
export const paymentConfigGetOrders = (params = {}) => {
    return $axios.get('paymentConfig/getOrders', { params })
}
//新增案件
export const paymentCaseAdd = (data) => {
    return $axios.post('paymentCase/add', data)
}
// 获取案件数据
export const paymentCaseCaseData = (params = {}) => {
    return $axios.get('paymentCase/caseData', { params })
}
// 获取事由
export const paymentConfigReason = (params = {}) => {
    return $axios.get('paymentConfig/reason', { params })
}
// 获取奖惩案件数据
export const paymentCaseBonusPenalty = (params = {}) => {
    return $axios.get('paymentCase/bonusPenalty', { params })
}
// 获取已兑现记录
export const paymentCaseBonusPaied = (params) => {
    return $axios.get('paymentCase/bonusPaied', { params })
}
// 获取总务提成列表
export const paymentIntegralList = (params = {}) => {
    return $axios.get('paymentIntegral/list', { params })
}
// 添加||编辑总务提成积分
export const paymentIntegralAddSalary = (data) => {
    return $axios.post('paymentIntegral/addSalary', data)
}
// 添加提成
export const userPerkAdd = (data) => {
    return $axios.post('userPerk/add', data)
}
// 编辑提成
export const userPerkEdit = (data) => {
    return $axios.post('userPerk/edit', data)
}
//删除提成
export const userPerkDel = (params = {}) => {
    return $axios.get('userPerk/del', { params })
}
// 获取佣金汇总
export const paymentSalarySummary = (params = {}) => {
    return $axios.get('paymentSalary/summary', { params })
}
// 获取团队数据
export const ordersConfigGetTeam = (params = {}) => {
    return $axios.get('ordersConfig/getTeam', { params })
}
//更改佣金单状态
export const paymentSalaryState = (data) => {
    return $axios.post('paymentSalary/state', data)
}
// 获取财务详情
export const paymentRecordDetailed = (params = {}) => {
    return $axios.get('paymentRecord/detailed', { params })
}
// 获取货代运费详情
export const paymentShippingDetailed = (params = {}) => {
    return $axios.get('paymentShipping/detailed', { params })
}
// 获取转入货款明细
export const paymentDetailed = (params = {}) => {
    return $axios.get('payment/detailed', { params })
}
// 获取财务银行配置
export const paymentConfigGetBank = (params = {}) => {
    return $axios.get('paymentConfig/getBank', { params })
}
// 转出货况获取采购单
export const paymentPurcharsePayOrderList = (params = {}) => {
    return $axios.get('paymentPurcharse/payOrderList', { params })
}
// 获取转出货款付款记录
export const paymentPurcharsePaidRecord = (params = {}) => {
    return $axios.get('paymentPurcharse/paidRecord', { params })
}
// 转出货款获取供应商
export const paymentPurcharseSupplier = (params = {}) => {
    return $axios.get('paymentPurcharse/supplier', { params })
}
// 支出获取产品
export const pcModel = (params = {}) => {
    return $axios.get('pc/model', { params })
}
// 获取支出种类
export const pcPayInOrOutCategory = (params = {}) => {
    return $axios.get('pc/payInOrOutCategory', { params })
}
// 新增支出
export const payiioAdd = (data) => {
    return $axios.post('payiio/add', data)
}
// 获取支出列表
export const payiioList = (params = {}) => {
    return $axios.get('payiio/list', { params })
}
// 获取支出列表明细
export const payiioItems = (params = {}) => {
    return $axios.get('payiio/items', { params })
}
// 查看支出详情
export const payiioDetailed = (params = {}) => {
    return $axios.get('payiio/detailed', { params })
}
// 添加明细信息
export const payiioOneItems = (params = {}) => {
    return $axios.get('payiio/oneItems', { params })
}
// 删除收支记录
export const payiioDel = (params = {}) => {
    return $axios.get('payiio/del', { params })
}
// 导入运费
export const paymentShippingImport = (data) => {
    return $axios.post('paymentShipping/import', data)
}
// 导入收支信息
export const payiioImport = (data) => {
    return $axios.post('payiio/import', data)
}
// 客户添加采购单
export const cpoAdd = (data) => {
    return $axios.post('cpo/add', data)
}
// 客户采购单列表
export const cpoList = (data) => {
    return $axios.post('cpo/list', data)
}
// 客户采购单详情
export const cpoItem = (data) => {
    return $axios.post('cpo/item', data)
}
// 编辑采购单
export const cpoEdit = (data) => {
    return $axios.post('cpo/edit', data)
}
// 客户采购单form Order 搜索单号
export const ocGetCustomerOrders = (params = {}) => {
    return $axios.get('oc/getCustomerOrders', { params })
}
// form Order获取订单产品
export const cpoFromOrders = (params = {}) => {
    return $axios.get('cpo/fromOrders', { params })
}
// 获取客户产品历史价格和记录
export const cpoProductRecord = (params = {}) => {
    return $axios.get('cpo/productRecord', { params })
}
// 删除客户采购单
export const cpoDel = (params = {}) => {
    return $axios.get('cpo/del', { params })
}
// 删除客户采购单详情
export const cpoDelItems = (params = {}) => {
    return $axios.get('cpo/delItems', { params })
}
// 客户采购单from Qtn 搜索单号
export const ocGetInquiry = (params = {}) => {
    return $axios.get('oc/getInquiry', { params })
}
//客户采购单qtn产品项
export const cpoQuotation = (params = {}) => {
    return $axios.get('cpo/quotation', { params })
}
// 获取订单状态记录
export const ocStatusRecord = (params = {}) => {
    return $axios.get('oc/statusRecord', { params })
}
// 修改客户采购单状态
export const cpoStatus = (params = {}) => {
    return $axios.get('cpo/status', { params })
}
// 修改客户销售单状态
export const ordersStatus = (data) => {
    return $axios.post('orders/status', data)
}
// 获取供应商联系人
export const ocSupplierContanct = (params = {}) => {
    return $axios.get('oc/supplierContanct', { params })
}
// 收支编辑
export const payiioEdit = (data) => {
    return $axios.post('payiio/edit', data)
}
// 导入薪资
export const userSalaryImport = (data) => {
    return $axios.post('userSalary/import', data)
}
// 佣金导入
export const paymentSalaryImport = (data) => {
    return $axios.post('paymentSalary/import', data)
}
// 获取应收应付列表
export const payaoList = (params = {}) => {
    return $axios.get('payao/list', { params })
}
// 获取应收应付详情信息
export const payaoItems = (params = {}) => {
    return $axios.get('payao/items', { params })
}
// 客户资金池添加
export const fdplAdd = (data) => {
    return $axios.post('fdpl/add', data)
}
// 获取资金池列表
export const fdplList = (params = {}) => {
    return $axios.get('fdpl/list', { params })
}
// 获取详情 + 编辑资金池
export const fdplEdit = (urlInfo, data) => {
    return $axios.post(urlInfo, data)
}
// 获取操作日志
export const fdplLog = (params = {}) => {
    return $axios.get('fdpl/log', { params })
}
// 财务配置获取团队接口 
export const pcTeamList = (params = {}) => {
    return $axios.get('pc/teamList', { params })
}
// 删除薪资列表项
export const userSalaryDel = (params = {}) => {
    return $axios.get('userSalary/del', { params })
}
// 编辑总务积分
export const paymentIntegralEdit = (data) => {
    return $axios.post('paymentIntegral/edit', data)
}
// 删除奖惩
export const paymentCaseDel = (params = {}) => {
    return $axios.get('paymentCase/del', { params })
}
// 删除责任人
export const paymentCaseDelUser = (data) => {
    return $axios.post('paymentCase/delUser', data)
}
//转出货款
export const paymentPurcharseAdd = (data) => {
    return $axios.post('paymentPurcharse/add', data)
}
// 转出货款详情
export const paymentPurcharseDetailed = (params = {}) => {
    return $axios.get('paymentPurcharse/detailed', { params })
}
// 导出转出货款数据
export const paymentPurcharseExport = (params = {}) => {
    return $axios.get('paymentPurcharse/export', { params })
}
//导出转移订单记录
export const paymentExport = (params = {}) => {
    return $axios.get('payment/export', { params })
}
// 获取运输方式
export const pcShippingWay = (params = {}) => {
    return $axios.get('pc/shippingWay', { params })
}
//订单结算
export const osAdd = (data) => {
    return $axios.post('os/add', data)
}
// 获取Settled Orders列表
export const osList = (params = {}) => {
    return $axios.get('os/list', { params })
}
// 获取已结算订单
export const osOrders = (params = {}) => {
    return $axios.get('os/orders', { params })
}
// 撤销结算
export const osDel = (data) => {
    return $axios.post('os/del', data)
}
// 获取SKU
export const ocGetSku = (params = {}) => {
    return $axios.get('oc/getSku', { params })
}
// 创建PI
export const ordersCreatePI = (params = {}) => {
    return $axios.get('orders/createPI', { params })
}
// 获取佣金单修改记录
export const ordersCommissionLog = (params = {}) => {
    return $axios.get('orders/commissionLog', { params })
}
// 相关订单带出数据
export const ordersGetRelatePI = (params = {}) => {
    return $axios.get('orders/getRelatePI', { params })
}
// 获取相关售后补发单
export const ordersReshipment = (params = {}) => {
    return $axios.get('orders/reshipment', { params })
}
// 财务获取售后补发单
export const payroReshipmeOrders = (params = {}) => {
    return $axios.get('payro/reshipmeOrders', { params })
}
// 新增售后补发单扣款
export const payroAdd = (data) => {
    return $axios.post('payro/add', data)
}
// 售后补发单扣款列表
export const payroList = (params = {}) => {
    return $axios.get('payro/list', { params })
}
// 采购单日志
export const purchaseOrderLog = (params = {}) => {
    return $axios.get('purchaseOrder/log', { params })
}
// 售后补发详情
export const payroDetailed = (params = {}) => {
    return $axios.get('payro/detailed', { params })
}
// 编辑售后补发单
export const payroEdit = (data) => {
    return $axios.post('payro/edit', data)
}
//退款至资金池
export const payaoAdd = (data) => {
    return $axios.post('payao/add', data)
}
// 新增欠款池
export const payoweAdd = (data) => {
    return $axios.post('payowe/add', data)
}
// 欠款池列表
export const payoweList = (params = {}) => {
    return $axios.get('payowe/list', { params })
}
//欠款池日志
export const payoweLog = (params = {}) => {
    return $axios.get('payowe/log', { params })
}
//获取供应商/客户
export const pcGetCompany = (params = {}) => {
    return $axios.get('pc/getCompany', { params })
}
//编辑欠款池
export const payoweEdit = (data) => {
    return $axios.post('payowe/edit', data)
}
// 转出货款获取欠款池金额
export const payoweDropdown = (params = {}) => {
    return $axios.get('payowe/dropdown', { params })
}
// 客户新增银行
export const ordersAddClientBank = (data) => {
    return $axios.post('orders/addClientBank', data)
}
// 客户销售单提交产品同步数据
export const ordersSureSync = (data) => {
    return $axios.post('orders/sureSync', data)
}
//客户销售单提交产品同步数据
export const cpoSureSync = (data) => {
    return $axios.post('cpo/sureSync', data)
}
// 客户销售单原订单数据
export const ordersOriginal = (params = {}) => {
    return $axios.get('orders/original', { params })
}
//客户采购单原订单数据
export const cpoOriginal = (params = {}) => {
    return $axios.get('cpo/original', { params })
}
// 客户采购单获取owner和采购方
export const cpoGetUser = (params = {}) => {
    return $axios.get('cpo/getUser', { params })
}
//财务报表-sales
export const psOrders = (params = {}) => {
    return $axios.get('ps/orders', { params })
}
// 财务报表-purchase
export const psPurchase = (params = {}) => {
    return $axios.get('ps/purchase', { params })
}
// 获取承担人
export const ordersUndertaker = (params = {}) => {
    return $axios.get('orders/undertaker', { params })
}
//新增报销单
export const payexAdd = (data) => {
    return $axios.post('payex/add', data)
}
//编辑报销单
export const payexEdit = (data) => {
    return $axios.post('payex/edit', data)
}
//获取报销单列表
export const payexList = (params = {}) => {
    return $axios.get('payex/list', { params })
}
//删除报销单
export const payexDel = (params = {}) => {
    return $axios.get('payex/del', { params })
}
//编辑报销单状态(提交、撤回)
export const payexStatus = (params = {}) => {
    return $axios.get('payex/status', { params })
}
//审核报销单
export const payexAuditing = (data) => {
    return $axios.post('payex/auditing', data)
}
//日志
export const payexLog = (params = {}) => {
    return $axios.get('payex/log', { params })
}
//报销单获取PI
export const payexOrders = (params = {}) => {
    return $axios.get('payex/orders', { params })
}
// 获取报销单详情
export const payexDetailed = (params = {}) => {
    return $axios.get('payex/detailed', { params })
}
// 获取报销单付款记录和每次付款详情
export const payexPayDetailed = (params = {}) => {
    return $axios.get('payex/payDetailed', { params })
}
// 获取订单来源
export const ocFromType = (params = {}) => {
    return $axios.get('oc/fromType', { params })
}
// 销售单已读
export const ordersRead = (params = {}) => {
    return $axios.get('orders/read', { params })
}
// 客户采购单已读
export const cpoRead = (params = {}) => {
    return $axios.get('cpo/read', { params })
}
// 采购任务已读
export const purteskRead = (params = {}) => {
    return $axios.get('purtesk/read', { params })
}
// 应收应付获取责任人
export const payaoPersonLiable = (params = {}) => {
    return $axios.get('payao/personLiable', { params })
}
// 创建资金池获取客户
export const fdplCustomerInfo = (params = {}) => {
    return $axios.get('fdpl/customerInfo', { params })
}
// 财务报表获取联系人
export const psCustomerInfo = (params = {}) => {
    return $axios.get('ps/customerInfo', { params })
}
//获取联系人订单数量
export const cmCustomerOrder = (params = {}) => {
    return $axios.get('cm/customerOrder', { params })
}
// 办公设备搜索下拉框
export const paymentOfficeSearch = (params = {}) => {
    return $axios.get('paymentOffice/search', { params })
}
//财务记录页面站点搜索下拉框
export const paymentRecordWebsiteSearch = (params = {}) => {
    return $axios.get('paymentRecord/websiteSearch', { params })
}
//办公设备分配设备获取使用人
export const paymentOfficeGetUser = (params = {}) => {
    return $axios.get('paymentOffice/getUser', { params })
}